"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ROOT_CSS = (0, _glamor.css)({
  border: 0,
  outline: 0,
  touchAction: 'none'
});

var _default = function _default(_ref) {
  var ariaLabel = _ref['aria-label'],
      children = _ref.children,
      className = _ref.className,
      mode = _ref.mode;
  return _react.default.createElement(_Context.default.Consumer, null, function (context) {
    return _react.default.createElement("button", {
      "aria-label": ariaLabel || (mode === 'left' ? 'left' : 'right'),
      className: (0, _classnames.default)(ROOT_CSS + '', className),
      onClick: mode === 'left' ? context.scrollOneLeft : context.scrollOneRight,
      type: "button"
    }, _react.default.createElement("div", {
      className: "slider"
    }, children));
  });
};

exports.default = _default;